/* eslint-disable */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Tooltip,
  makeStyles,
  createStyles,
  Box,
  Button,
  Card,
  CardHeader,
  Input,
  Theme,
  withStyles,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import CircularProgress from "@material-ui/core/CircularProgress";

import {
  HStack,
  Circle,
  Heading,
  Image,
  Checkbox,
  Container,
} from "@chakra-ui/react";
import { Row } from "reactstrap";
import {
  get_all_questions_configuration,
  getAllRiskCriteriasConfigurations,
  add_questions_configuration,
  delete_questions_configuration,
  edit_questions_configuration_values,
} from "../../utils/store/actions/risk.actions";
import { getSections, getEnums } from "../../utils/store/actions/survey.action";

const useStyles = (theme: Theme) =>
  createStyles({
    root: {
      // width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "20%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
      flexBasis: "40.33%",
    },
    paper: {
      width: "80%",
      backgroundColor: "#F5F6FF",
      margin: "7%",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    weight: {
      display: "flex",
      marginLeft: "10vh",
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    table: {
      height: "30vh",
    },
  });
class RiskAnswers extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: true,
      checked: [],
    };
  }
  componentDidMount() {
    this.props.getSections("client").then(() => {
      this.setState({ loading: false });
    });
    this.props.getEnums();
    this.props.getAllRiskCriteriasConfigurations().then(() => {
      this.setState({
        criteria: this.props.Risk.risk_criterias_configurations.content,
      });
    });
    this.props.get_all_questions_configuration().then(() => {
      this.setState({ checked: this.props.Risk.risk_questions });
    });
  }

  componentWillUnmount() {
    this.props.get_all_questions_configuration().then(() => {
      this.setState({ checked: this.props.Risk.risk_questions });
    });
  }
  render() {
    if (
      this.props.Surveys.sort_sections &&
      this.props.Surveys.sections &&
      this.props.Surveys.enums &&
      this.props.Risk.risk_criterias_configurations.content &&
      this.props.Risk.risk_questions
    ) {
      if (this.state.loading) {
        return <CircularProgress color="inherit" />;
      } else {
        const { t, classes } = this.props;
        return (
          <div>
            <Box
              style={{
                margin: "50px",
                display: "flex",
                alignItems: "top",
              }}
            >
              <HStack cursor="pointer">
                <Heading
                  fontSize="18px"
                  fontFamily="Inter, sans-serif"
                  color="brand.bf3"
                >
                  {t("CONFIGURATION_OF_RISK_PROFILE_ANSWERS")}
                </Heading>
                <Image src="/icon/check-circle.svg" />
              </HStack>
            </Box>
            <Box
              style={{
                display: "flex",
                margin: "50px",
                flexDirection: "column",
              }}
            >
              <span>{t("ANSWER_CONFIGURATION_SCORE")}</span>
              <span>{t("ANSWER_CONFIGURATION_SCORE_EXAMPLE")}</span>
            </Box>
            <Paper className={classes.paper}>
              <Row
                style={{
                  display: "block",
                  marginRight: "0px",
                  marginLeft: "0px",
                }}
              >
                <div className={classes.root}>
                  {this.state.criteria.map((criteria: any) => (
                    <Accordion key={criteria.id}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-label="Expand"
                        aria-controls="additional-actions1-content"
                        id="additional-actions1-header"
                      >
                        {t(criteria.criteria)[0].toUpperCase() +
                          t(criteria.criteria).slice(1).toLowerCase()}
                      </AccordionSummary>
                      <AccordionDetails style={{ maxHeight: "60vh" }}>
                        <TableContainer component={Paper}>
                          <Table stickyHeader aria-label="a dense table">
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell id="SCORE" align="center">
                                  Score
                                </TableCell>
                                <TableCell id="ALERTE" align="center">
                                  {t("ALERTS")}
                                </TableCell>
                                <TableCell id="EDIT" align="center">
                                  {t("EDIT")}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {this.props.Surveys.sections?.map((sec: any) =>
                                sec?.subSection
                                  .sort((a: any, b: any) =>
                                    a.sectionOrder &&
                                    b.sectionOrder &&
                                    a.sectionOrder > b.sectionOrder
                                      ? 1
                                      : -1
                                  )
                                  .map(
                                    (sub: any) =>
                                      sub.questions !== [] && (
                                        <>
                                          {sub.questions
                                            .sort((a: any, b: any) =>
                                              a.questionOrder &&
                                              b.questionOrder &&
                                              a.questionOrder > b.questionOrder
                                                ? 1
                                                : -1
                                            )
                                            .map(
                                              (q: any) =>
                                                this.state.checked.find(
                                                  (checked: any) => {
                                                    if (
                                                      checked.key === q.key &&
                                                      checked
                                                        .criteriaConfiguration
                                                        .criteria ===
                                                        criteria.criteria
                                                    ) {
                                                      return true;
                                                    } else {
                                                      return false;
                                                    }
                                                  }
                                                ) && (
                                                  <>
                                                    <TableRow
                                                      style={{
                                                        backgroundColor: `${
                                                          q.type === "TITLE"
                                                            ? "#C7A3D1"
                                                            : "lightgrey"
                                                        }`,
                                                      }}
                                                    >
                                                      <TableCell
                                                        component="th"
                                                        scope="row"
                                                      >
                                                        {q.type === "TITLE" ? (
                                                          <Tooltip
                                                            title={t(
                                                              "TITLE_OF_QUESTION"
                                                            )}
                                                          >
                                                            <strong>
                                                              [{q.key}] {t(q.label)} **
                                                            </strong>
                                                          </Tooltip>
                                                        ) : (
                                                          <>
                                                            [{q.key}] {t(q.label)}
                                                            {q.personType && (
                                                              <small>
                                                                (
                                                                {t(
                                                                  q.personType
                                                                )}
                                                                )
                                                              </small>
                                                            )}
                                                          </>
                                                        )}
                                                      </TableCell>
                                                      <TableCell
                                                        size="small"
                                                        align="right"
                                                      ></TableCell>
                                                      <TableCell
                                                        size="small"
                                                        align="right"
                                                      ></TableCell>
                                                      <TableCell
                                                        size="small"
                                                        align="right"
                                                      ></TableCell>
                                                    </TableRow>
                                                    {this.state.checked
                                                      .find(
                                                        (checked: any) =>
                                                          checked.key === q.key
                                                      )
                                                      .valueConfigurations?.sort()
                                                      .map((values: any) => {
                                                        return (
                                                          <TableRow>
                                                            <TableCell
                                                              component="th"
                                                              scope="row"
                                                            >
                                                              {!values.label.includes(
                                                                "ENUMS"
                                                              )
                                                                ? t(
                                                                    `ENUMS.${values.label}`
                                                                  )
                                                                : t(
                                                                    `${values.label}`
                                                                  )}
                                                            </TableCell>
                                                            <TableCell
                                                              size="small"
                                                              align="center"
                                                            >
                                                              {this.state[
                                                                `edit_${values.value}${q.label}`
                                                              ] ? (
                                                                <Input
                                                                  value={
                                                                    this.state[
                                                                      values
                                                                        .value
                                                                    ].weight
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.setState(
                                                                      {
                                                                        [values.value]:
                                                                          {
                                                                            ...this
                                                                              .state[
                                                                              values
                                                                                .value
                                                                            ],
                                                                            weight:
                                                                              e
                                                                                .target
                                                                                .value,
                                                                          },
                                                                      }
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                values.weight
                                                              )}
                                                            </TableCell>
                                                            <TableCell
                                                              size="small"
                                                              align="center"
                                                            >
                                                              {this.state[
                                                                `edit_${values.value}${q.label}`
                                                              ] ? (
                                                                <Checkbox
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.setState(
                                                                      {
                                                                        [values.value]:
                                                                          {
                                                                            ...this
                                                                              .state[
                                                                              values
                                                                                .value
                                                                            ],
                                                                            alert:
                                                                              e
                                                                                .target
                                                                                .checked,
                                                                          },
                                                                      }
                                                                    )
                                                                  }
                                                                  id="ALERTE"
                                                                  isChecked={
                                                                    this.state[
                                                                      values
                                                                        .value
                                                                    ].alert
                                                                  }
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "primary checkbox",
                                                                  }}
                                                                />
                                                              ) : (
                                                                <Checkbox
                                                                  id="ALERTE"
                                                                  isDisabled={
                                                                    true
                                                                  }
                                                                  isChecked={
                                                                    values.alert
                                                                  }
                                                                  inputProps={{
                                                                    "aria-label":
                                                                      "primary checkbox",
                                                                  }}
                                                                />
                                                              )}
                                                            </TableCell>
                                                            <TableCell size="small">
                                                              {this.state[
                                                                `edit_${values.value}${q.label}`
                                                              ] ? (
                                                                <Button
                                                                  onClick={() => {
                                                                    this.props
                                                                      .edit_questions_configuration_values(
                                                                        criteria.id,
                                                                        this.state.checked.find(
                                                                          (
                                                                            checked: any
                                                                          ) =>
                                                                            checked.key ===
                                                                              q.key &&
                                                                            checked
                                                                              .criteriaConfiguration
                                                                              .criteria ===
                                                                              criteria.criteria
                                                                        ).id,
                                                                        this
                                                                          .state[
                                                                          values
                                                                            .value
                                                                        ],
                                                                        values.value
                                                                      )
                                                                      .then(
                                                                        () =>
                                                                          this.props
                                                                            .get_all_questions_configuration()
                                                                            .then(
                                                                              () => {
                                                                                this.setState(
                                                                                  {
                                                                                    checked:
                                                                                      this
                                                                                        .props
                                                                                        .Risk
                                                                                        .risk_questions,
                                                                                  }
                                                                                );
                                                                              }
                                                                            )
                                                                      );
                                                                    this.setState(
                                                                      {
                                                                        [`edit_${values.value}${q.label}`]:
                                                                          !this
                                                                            .state[
                                                                            `edit_${values.value}${q.label}`
                                                                          ],
                                                                      }
                                                                    );
                                                                  }}
                                                                >
                                                                  <SaveIcon />
                                                                </Button>
                                                              ) : (
                                                                <Button
                                                                  onClick={() =>
                                                                    this.setState(
                                                                      {
                                                                        [`edit_${values.value}${q.label}`]:
                                                                          !this
                                                                            .state[
                                                                            `edit_${values.value}${q.label}`
                                                                          ],
                                                                        [values.value]:
                                                                          {
                                                                            ...this
                                                                              .state[
                                                                              values
                                                                                .value
                                                                            ],
                                                                            score:
                                                                              values.weight,
                                                                            alert:
                                                                              values.alert,
                                                                          },
                                                                      }
                                                                    )
                                                                  }
                                                                >
                                                                  <EditIcon />
                                                                </Button>
                                                              )}
                                                            </TableCell>
                                                          </TableRow>
                                                        );
                                                      })}
                                                  </>
                                                )
                                            )}
                                        </>
                                      )
                                  )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </Row>
            </Paper>
          </div>
        );
      }
    } else {
      return (
        <>
          {/* Page content */}
          <Container className="mt--7" fluid>
            {/* Table */}
            <Row>
              <div className="col">
                <Card className="shadow">
                  <CardHeader className="fa5 border-0">
                    <h3 className="mb-0">Questions disponibles</h3>
                  </CardHeader>
                </Card>
              </div>
            </Row>
          </Container>
        </>
      );
    }
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getEnums,
  getSections,
  get_all_questions_configuration,
  getAllRiskCriteriasConfigurations,
  add_questions_configuration,
  delete_questions_configuration,
  edit_questions_configuration_values,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withTranslation()(RiskAnswers)));
